import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@NgModule({
  exports: [MatButtonModule, MatDialogModule, MatSnackBarModule, MatMenuModule],
  providers: [{ provide: MAT_SNACK_BAR_DATA, useValue: {} }]
})
export class MaterialModule {}
